import React from 'react';
import { Container, Section } from '../ui/Section';
import { DoodleBurst, DoodleCircle, DoodleHeart } from '../brand/Doodles';
type Fact = {
  label: string;
  title: string;
  copy: string;
  doodle: React.ReactNode;
  accent: string;
};
const facts: Fact[] = [{
  label: 'When',
  title: 'Thursday Nights',
  copy: 'Worship begins at 7:30 PM during the school year.',
  doodle: <DoodleBurst className="h-10 w-10" color="var(--bcm-dark-blue)" data-id="element-210" data-mp="2iavr3llo61vt" />,
  accent: 'bg-brand-yellow'
}, {
  label: 'Where',
  title: 'UCF Student Union',
  copy: 'Most weeks, find BCM on the third floor in Cape Florida Ballroom, Room 316.',
  doodle: <DoodleCircle className="h-10 w-16" color="var(--bcm-dark-blue)" data-id="element-211" data-mp="2s8jxx9wjuzuc" />,
  accent: 'bg-brand-blue'
}, {
  label: 'Who',
  title: 'Everyone Is Welcome',
  copy: 'You do not have to be Baptist—or even Christian—to attend.',
  doodle: <DoodleHeart className="h-10 w-10" color="var(--bcm-dark-blue)" data-id="element-212" data-mp="swh7ffpid576" />,
  accent: 'bg-brand-pink'
}];
export function QuickFacts() {
  return <Section className="bg-[#fffdf6] py-16 sm:py-20" labelledBy="quick-facts-heading" data-id="element-213" data-mp="3kl6rmgkh5nt0">
      <Container data-id="element-214" data-mp="3om0gpd9nl8nh">
        <h2 id="quick-facts-heading" className="font-serif text-3xl font-semibold leading-tight text-brand-navy sm:text-4xl" data-id="element-215" data-mp="3olguhkcyzy3n">
          Your first visit, at a glance
        </h2>

        <ul className="mt-9 grid gap-5 sm:grid-cols-3" data-id="element-216" data-mp="27pfl9kpr0sq">
          {facts.map(fact => <li key={fact.label} className="relative flex flex-col rounded-[22px] border-2 border-brand-navy bg-white p-6" data-id="element-217" data-mp="74fq7hdr146r">
              <span className={`absolute -top-3 left-6 rounded-full px-3 py-1 font-meta text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-navy ${fact.accent}`} data-id="element-218" data-mp="g6grcpc3sadp">
                {fact.label}
              </span>
              <div className="mt-3" aria-hidden="true" data-id="element-219" data-mp="2mvvbfo8dlxfy">
                {fact.doodle}
              </div>
              <h3 className="mt-4 font-display text-xl font-bold text-brand-navy sm:text-2xl" data-id="element-220" data-mp="3q6hi1zokqi9e">
                {fact.title}
              </h3>
              <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink" data-id="element-221" data-mp="3l8zhawkpn9ch">{fact.copy}</p>
            </li>)}
        </ul>
      </Container>
    </Section>;
}